const ORDER = [
  "intro",
  "issues",
  "edu1",
  "routine",
  "edu2",
  "enamel",
  "loading",
  "results",
];

const PDP_URL = "https://larine.co";

const ISSUE_OPTIONS = [
  "Teeth sensitivity",
  "Yellow or stained teeth",
  "Bad breath",
  "Puffy or swollen gums",
  "None of the above",
];

const ROUTINE_OPTIONS = [
  "Brushing",
  "Whitening strips",
  "Mouthwash",
  "Flossing",
  "Desensitizing toothpaste",
  "None of the above",
];

const ENAMEL_ITEMS = [
  {
    label: "Discomfort to cold, hot or sweet foods",
    img: "https://cdn.shopify.com/s/files/1/0904/3869/7251/files/results.jpg?v=1777907055",
  },
  {
    label: "Yellowish teeth",
    img: "https://cdn.shopify.com/s/files/1/0904/3869/7251/files/sign-yellow.jpg?v=1777907053",
  },
  {
    label: "Thinning and translucent teeth",
    img: "https://cdn.shopify.com/s/files/1/0904/3869/7251/files/sign-translucent.jpg?v=1777907053",
  },
  {
    label: "Notches or indentations",
    img: "https://cdn.shopify.com/s/files/1/0904/3869/7251/files/sign-notches.jpg?v=1777907054",
  },
];

const LOADING_STEPS = [
  "Analyzing your dental concerns",
  "Matching with the right formula",
  "Calibrating your remineralizing routine",
  "Finalizing your 50% discount code",
];

let step = "intro";
let issues = [];
let routine = [];
let enamelSigns = [];
let loadProgress = 0;
let loadStage = 0;
let loadingTimers = [];
let loadingIntervalId = null;

function stepIndex() {
  return ORDER.indexOf(step);
}

function progressFraction() {
  const i = stepIndex();
  return (i / (ORDER.length - 1)) * 100;
}

function go(delta) {
  const i = stepIndex();
  const next = Math.max(0, Math.min(ORDER.length - 1, i + delta));
  setStep(ORDER[next]);
}

function toggleSelection(arr, val) {
  if (val === "None of the above") {
    return arr.includes(val) ? [] : [val];
  }
  const filtered = arr.filter((v) => v !== "None of the above");
  return filtered.includes(val)
    ? filtered.filter((v) => v !== val)
    : [...filtered, val];
}

function stopLoadingAnimation() {
  loadingTimers.forEach((id) => clearTimeout(id));
  loadingTimers = [];
  if (loadingIntervalId) {
    clearInterval(loadingIntervalId);
    loadingIntervalId = null;
  }
}

function startLoadingAnimation() {
  stopLoadingAnimation();
  loadProgress = 0;
  loadStage = 0;

  const stages = [800, 1700, 2600, 3500];
  stages.forEach((t, i) => {
    loadingTimers.push(
      setTimeout(() => {
        loadStage = i + 1;
        render();
      }, t)
    );
  });

  loadingIntervalId = setInterval(() => {
    loadProgress = Math.min(100, loadProgress + 100 / 42);
    renderLoadingOnly();
  }, 100);

  loadingTimers.push(
    setTimeout(() => {
      stopLoadingAnimation();
      setStep("results");
    }, 4200)
  );
}

function setStep(next) {
  if (step === "loading") {
    stopLoadingAnimation();
  }
  step = next;
  if (step === "loading") {
    startLoadingAnimation();
  }
  render();
}

function pillClass(active) {
  const base =
    "w-full rounded-full border-2 px-6 py-4 text-center font-semibold transition-all";
  return active
    ? `${base} border-primary bg-primary-soft text-primary-deep`
    : `${base} border-border bg-card text-foreground hover:border-primary/50`;
}

function enamelCardClass(active) {
  const base =
    "flex flex-col overflow-hidden rounded-2xl border-2 bg-card text-left transition-all";
  return active
    ? `${base} border-primary bg-primary-soft`
    : `${base} border-border hover:border-primary/50`;
}

function renderLoadingOnly() {
  if (step !== "loading") return;
  const pctEl = document.getElementById("loading-pct");
  const ring = document.getElementById("loading-ring-progress");
  if (pctEl) pctEl.textContent = `${Math.round(loadProgress)}%`;
  if (ring) {
    const c = 2 * Math.PI * 44;
    ring.setAttribute(
      "stroke-dashoffset",
      String(c * (1 - loadProgress / 100))
    );
  }
  syncLoadingList();
}

function syncLoadingList() {
  LOADING_STEPS.forEach((_, i) => {
    const row = document.getElementById(`loading-row-${i}`);
    if (!row) return;
    const done = loadStage > i;
    row.className = done
      ? "flex items-center gap-3 rounded-2xl px-4 py-3 transition-all bg-primary-soft text-primary-deep"
      : "flex items-center gap-3 rounded-2xl px-4 py-3 transition-all text-muted-foreground";
    const icon = row.querySelector("[data-loading-icon]");
    if (icon) {
      if (done) {
        icon.className =
          "flex h-6 w-6 items-center justify-center rounded-full border-2 border-primary bg-primary text-primary-foreground";
        icon.innerHTML =
          '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="h-4 w-4"><path d="M20 6 9 17l-5-5"/></svg>';
      } else {
        icon.className =
          "flex h-6 w-6 items-center justify-center rounded-full border-2 border-border";
        icon.innerHTML =
          '<span class="h-2 w-2 rounded-full bg-current animate-pulse"></span>';
      }
    }
  });
}

function render() {
  ORDER.forEach((s) => {
    const el = document.getElementById(`step-${s}`);
    if (el) el.classList.toggle("hidden", s !== step);
  });

  const showBack =
    step !== "intro" && step !== "loading" && step !== "results";
  document.getElementById("btn-back").classList.toggle("hidden", !showBack);
  document
    .getElementById("header-spacer")
    .classList.toggle("hidden", showBack);

  const showProgress = step !== "intro" && step !== "results";
  document
    .getElementById("progress-wrap")
    .classList.toggle("hidden", !showProgress);
  const bar = document.getElementById("progress-bar");
  if (bar) bar.style.width = `${progressFraction()}%`;
  const bar_im = document.getElementById("progress-bar-image");
  if (bar_im) bar_im.style.left = `${progressFraction()}%`;

  ISSUE_OPTIONS.forEach((label) => {
    const btn = document.querySelector(`[data-issue="${attrQuote(label)}"]`);
    if (!btn) return;
    const active = issues.includes(label);
    btn.className = pillClass(active);
    const check = btn.querySelector("[data-pill-check]");
    if (check) check.classList.toggle("hidden", !active);
  });

  const issuesNext = document.getElementById("btn-issues-next");
  if (issuesNext) issuesNext.disabled = issues.length === 0;

  ROUTINE_OPTIONS.forEach((label) => {
    const btn = document.querySelector(`[data-routine="${attrQuote(label)}"]`);
    if (!btn) return;
    const active = routine.includes(label);
    btn.className = pillClass(active);
    const check = btn.querySelector("[data-pill-check]");
    if (check) check.classList.toggle("hidden", !active);
  });

  const routineNext = document.getElementById("btn-routine-next");
  if (routineNext) routineNext.disabled = routine.length === 0;

  ENAMEL_ITEMS.forEach(({ label }) => {
    const btn = document.querySelector(`[data-enamel="${attrQuote(label)}"]`);
    if (!btn) return;
    const active = enamelSigns.includes(label);
    btn.className = enamelCardClass(active);
    const check = btn.querySelector("[data-enamel-check]");
    if (check) check.classList.toggle("hidden", !active);
    const text = btn.querySelector("[data-enamel-text]");
    if (text) {
      text.className = active
        ? "text-sm font-semibold text-primary-deep"
        : "text-sm font-semibold text-foreground";
    }
  });

  const nonePill = document.getElementById("enamel-none-pill");
  if (nonePill) {
    const active = enamelSigns.includes("None of the above");
    nonePill.className = pillClass(active);
    const check = nonePill.querySelector("[data-pill-check]");
    if (check) check.classList.toggle("hidden", !active);
  }

  const enamelNext = document.getElementById("btn-enamel-next");
  if (enamelNext) enamelNext.disabled = enamelSigns.length === 0;

  if (step === "loading") {
    renderLoadingOnly();
  }
}

/** Safe double-quoted attribute fragment for querySelector */
function attrQuote(s) {
  return s.replace(/\\/g, "\\\\").replace(/"/g, '\\"');
}

function wire() {
  document.getElementById("btn-back").addEventListener("click", () => go(-1));

  document.getElementById("btn-intro-next").addEventListener("click", () => go(1));

  ISSUE_OPTIONS.forEach((label) => {
    document
      .querySelector(`[data-issue="${attrQuote(label)}"]`)
      .addEventListener("click", () => {
        issues = toggleSelection(issues, label);
        render();
      });
  });
  document.getElementById("btn-issues-next").addEventListener("click", () => go(1));

  document.getElementById("btn-edu1-next").addEventListener("click", () => go(1));

  ROUTINE_OPTIONS.forEach((label) => {
    document
      .querySelector(`[data-routine="${attrQuote(label)}"]`)
      .addEventListener("click", () => {
        routine = toggleSelection(routine, label);
        render();
      });
  });
  document.getElementById("btn-routine-next").addEventListener("click", () => go(1));

  document.getElementById("btn-edu2-next").addEventListener("click", () => go(1));

  ENAMEL_ITEMS.forEach(({ label }) => {
    document
      .querySelector(`[data-enamel="${attrQuote(label)}"]`)
      .addEventListener("click", () => {
        enamelSigns = toggleSelection(enamelSigns, label);
        render();
      });
  });
  document.getElementById("enamel-none-pill").addEventListener("click", () => {
    enamelSigns = toggleSelection(enamelSigns, "None of the above");
    render();
  });
  document.getElementById("btn-enamel-next").addEventListener("click", () => go(1));
}

document.addEventListener("DOMContentLoaded", () => {
  wire();
  render();
});
